import { render, staticRenderFns } from "./order_credit_bill_list.vue?vue&type=template&id=5965a732&scoped=true"
import script from "./order_credit_bill_list.vue?vue&type=script&lang=js"
export * from "./order_credit_bill_list.vue?vue&type=script&lang=js"
import style0 from "./order_credit_bill_list.vue?vue&type=style&index=0&id=5965a732&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965a732",
  null
  
)

export default component.exports